export default "__VITE_ASSET__DvPw5SLH__"